import { render, staticRenderFns } from "./copyrightFont.vue?vue&type=template&id=85c6db10&scoped=true&"
import script from "./copyrightFont.vue?vue&type=script&lang=js&"
export * from "./copyrightFont.vue?vue&type=script&lang=js&"
import style0 from "./copyrightFont.vue?vue&type=style&index=0&id=85c6db10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c6db10",
  null
  
)

export default component.exports